import React, { type ButtonHTMLAttributes, type ReactNode, useMemo } from 'react';

import './CircleButton.scss';

export interface CommonCircleButtonProps {
    children: ReactNode;
    ariaLabel: string;
    size?: 'small' | 'large' | 'xlarge';
    classes?: string;
    variant?: string;
    outline?: boolean;
}

type CircleButtonProps = CommonCircleButtonProps & ButtonHTMLAttributes<HTMLButtonElement>;

export const CircleButton = ({
    children,
    ariaLabel,
    size,
    classes,
    variant,
    outline = true,
    ...props
}: CircleButtonProps) => {
    const classNames = useMemo(() => {
        const classNames: string[] = ['yat-circle-button'];
        if (size) classNames.push(`yat-circle-button--${size}`);
        if (outline) classNames.push('yat-circle-button--outline');
        if (variant) classNames.push(`yat-circle-button--${variant}`);
        if (classes) classNames.push(classes);
        return classNames.join(' ');
    }, [size, outline, classes, variant]);

    return (
        <button className={classNames} aria-label={ariaLabel} {...props}>
            {children}
        </button>
    );
};
